import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { PrimaryButtonBase } from '@ad-scripts/presentation/components/common/button';

const RouterLinkButton = styled(Link)`
  ${PrimaryButtonBase};
  text-decoration: none;
`;
export default RouterLinkButton;
